import React from "react";

const ImageEmbed = ({ src, alt }) => {

    const image = '../../images/markdown-media/'+src


    return (
            // <StaticImage
            //     className="rounded-lg shadow-lg"
            //     src={src}
            //     alt={alt}
            // />
            //${src}
        <div>
            <p>{image}</p>
            <p>{alt}</p>
            {/* <GatsbyImage className="rounded-lg shadow-lg" alt={alt} image={image} /> */}
            {/* src="../../markdown-pages/6-0-0-0/6-1-0-0/plombier-bron.jpg" */}
            {/* src='../../images/markdown-media/plombier-bron.jpg' */}
            {/* <StaticImage 
                className="rounded-lg shadow-lg" 
                alt={alt}
                src={src}
            /> */}
            {/* <GatsbyImage
                image={data.myImage.childImageSharp.gatsbyImageData}
                alt="Texte alternatif de l'image"
            /> */}
        </div>
    );
};

export default ImageEmbed;